export * from './areaKoeficient.service';
import { AreaKoeficientService } from './areaKoeficient.service';
export * from './areaKoeficient.serviceInterface';
export * from './areaPrice.service';
import { AreaPriceService } from './areaPrice.service';
export * from './areaPrice.serviceInterface';
export * from './authorization.service';
import { AuthorizationService } from './authorization.service';
export * from './authorization.serviceInterface';
export * from './authorizationPassword.service';
import { AuthorizationPasswordService } from './authorizationPassword.service';
export * from './authorizationPassword.serviceInterface';
export * from './calculation.service';
import { CalculationService } from './calculation.service';
export * from './calculation.serviceInterface';
export * from './calculationType.service';
import { CalculationTypeService } from './calculationType.service';
export * from './calculationType.serviceInterface';
export * from './color.service';
import { ColorService } from './color.service';
export * from './color.serviceInterface';
export * from './customer.service';
import { CustomerService } from './customer.service';
export * from './customer.serviceInterface';
export * from './role.service';
import { RoleService } from './role.service';
export * from './role.serviceInterface';
export * from './service.service';
import { ServiceService } from './service.service';
export * from './service.serviceInterface';
export * from './serviceAreaPrice.service';
import { ServiceAreaPriceService } from './serviceAreaPrice.service';
export * from './serviceAreaPrice.serviceInterface';
export * from './stats.service';
import { StatsService } from './stats.service';
export * from './stats.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export const APIS = [AreaKoeficientService, AreaPriceService, AuthorizationService, AuthorizationPasswordService, CalculationService, CalculationTypeService, ColorService, CustomerService, RoleService, ServiceService, ServiceAreaPriceService, StatsService, UserService];
